module.exports = __webpack_public_path__ + "static/img/shuo.a7eb7b2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shuo.jpg
// module id = F3nf
// module chunks = 1